import { render, staticRenderFns } from "./FailQueue.vue?vue&type=template&id=76cc01fc&scoped=true&"
import script from "./FailQueue.vue?vue&type=script&lang=js&"
export * from "./FailQueue.vue?vue&type=script&lang=js&"
import style0 from "./FailQueue.vue?vue&type=style&index=0&id=76cc01fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cc01fc",
  null
  
)

export default component.exports